<template>
  <div class="already-allocated-con">
    <vue-good-table
        :columns="columns"
        :rows="rows"

    >
      <template slot="table-row" slot-scope="props">
    <span v-if="props.column.field === 'btn'">
      <button v-if="props.row.btn" class="order-btn" v-on:click.prevent="()=>onClick(props.row.id)">Allocated Order</button>
    </span>
        <span v-else>
      {{ props.formattedRow[props.column.field] }}
    </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
// import Step4 from './Step4.vue';
// import { sendOrder } from '../actions/Allocation';
import {VueGoodTable} from 'vue-good-table';


export default {
  name: 'Orders',
  props: {
    alreadyAllocatedData: Array
  },
  components: {
    VueGoodTable
  },
  data() {
    return {
      columns: [
        {
          label: 'Order ID',
          field: 'orderId',
          type: 'number',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter', // placeholder for filter input
            // filterValue: 'Jane', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            // filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'enter', //only trigger on enter not on keyup
          },
        },
        {
          label: 'Account ID',
          field: 'accountId',
          type: 'number',
        },
        {
          label: 'Account Name',
          field: 'accountName',
          type: 'string',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter', // placeholder for filter input
            // filterValue: 'Jane', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            // filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'enter', //only trigger on enter not on keyup
          },
        },
        {
          label: 'RD Email',
          field: 'email',
          type: 'string',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter', // placeholder for filter input
            // filterValue: 'Jane', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            // filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'enter', //only trigger on enter not on keyup
          },
        },
        {
          label: 'Product Type',
          field: 'type',
          type: 'string',
          filterOptions: {
            enabled: true,
            placeholder: 'Filter', // placeholder for filter input
            // filterValue: 'Jane', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            // filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'enter', //only trigger on enter not on keyup
          },
        },
        {
          label: 'Action Needed',
          field: 'btn',
          sortable: false
        },
      ],
      // rows: [
      //   {
      //     id: 1,
      //     orderId: 2,
      //     accountId: 3,
      //     accountName: 'sdasdasdasd',
      //     email: 'dsdfds@gmail.com',
      //     type: 'fdfsdfdsfsd',
      //     btn: '1'
      //   },
      //   {
      //     id: 2,
      //     orderId: 3,
      //     accountId: 4,
      //     accountName: 'sdasdasdasd',
      //     email: 'dsdfds@gmail.com',
      //     type: 'fdfsdfdsfsd',
      //     btn: '1'
      //   }
      //
      // ],
    }
  },
  mounted() {
  },
  computed: {
    rows(){
      return this.alreadyAllocatedData.map(item=>{
        return {
          id:item.orderId,
          orderId: item.orderId,
          accountId: item.accountId,
          accountName: item.accountName,
          email: item.rdEmail,
          type: item.productType,
          btn: item.actionNeeded
        }
      })
    }
  },
  methods: {
    onClick(id){
      document.location.href = "/rd/orders/allocation/"+id;
    }
  }
}
</script>